import dayjs from "dayjs";

export const createFormData = (item: Record<string, any>, image?: File | null): FormData => {
    const formData = new FormData();

    const isEventDayDateKey = (key: string) => /eventDays\[\d+\]\.date$/i.test(key);

    const normaliseEventDayDate = (value: unknown): string => {
        if (!value) return '';

        if (value instanceof Date) {
            if (Number.isNaN(value.getTime())) return '';
            return `${value.toISOString().slice(0, 10)}T00:00:00`;
        }

        if (typeof value === 'string') {
            const datePart = value.trim().slice(0, 10);
            if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
                return `${datePart}T00:00:00`;
            }
        }

        const parsed = dayjs(value as string | number | Date);
        if (!parsed.isValid()) return '';
        return `${parsed.format('YYYY-MM-DD')}T00:00:00`;
    };

    const appendToFormData = (key: string, value: any) => {
        if (isEventDayDateKey(key)) {
            const normalised = normaliseEventDayDate(value);
            formData.append(key, normalised);
        } else if (dayjs.isDayjs(value)) {
            // Convert Day.js object to ISO string
            const formattedDate = value.toISOString();
            formData.append(key, formattedDate);
            console.log(`Key: ${key}, Formatted Day.js Date: ${formattedDate}`);
        }else if (value instanceof Date) {
            // Format Date objects as a local ISO string without converting to UTC
            const formattedDate = value.getFullYear() +
                '-' +
                String(value.getMonth() + 1).padStart(2, '0') +
                '-' +
                String(value.getDate()).padStart(2, '0') +
                'T' +
                String(value.getHours()).padStart(2, '0') +
                ':' +
                String(value.getMinutes()).padStart(2, '0') +
                ':' +
                String(value.getSeconds()).padStart(2, '0');
            formData.append(key, formattedDate);
            console.log(`Key: ${key}, Formatted Date: ${formattedDate}`);
        } else if (Array.isArray(value)) {
            // Handle arrays by appending each item with an index
            value.forEach((v, index) => {
                appendToFormData(`${key}[${index}]`, v);
            });
        } else if (typeof value === 'object' && value !== null) {
            // Handle nested objects by appending keys recursively
            Object.entries(value).forEach(([nestedKey, nestedValue]) => {
                appendToFormData(`${key}.${nestedKey}`, nestedValue);
            });
        } else {
            // Append primitive values
            formData.append(key, value ?? '');
        }
    };

    Object.entries(item).forEach(([key, value]) => {
        appendToFormData(key, value);
    });

    if (image) {
        formData.append('image', image);
    }

    return formData;
};
